import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

export const initAmplitude = (apiKey: string) => {
  amplitude.init(apiKey, undefined, {
    serverZone: 'EU',
  });
};

export const setAmplitudeUser = (userId: string, userRole?: string) => {
  amplitude.setUserId(userId);
  if (userRole) {
    const identify = new amplitude.Identify();
    identify.set('role', userRole);
    amplitude.identify(identify);
  }
  amplitude.add(engagementPlugin());
};
